import React, { FC } from 'react'
import classNames from 'classnames'

import CollapseIcon from 'svg/SA/collapse-large.svg'

import styles from './CollapseToggle.module.scss'

type CollapseToggleProps = {
  isCollapsed: boolean
  onToggle: () => void
}

const CollapseToggle: FC<CollapseToggleProps> = ({ isCollapsed, onToggle }) => {
  return (
    <button
      type='button'
      className={styles.collapseToggle}
      onClick={onToggle}
      aria-expanded={!isCollapsed}
      title={isCollapsed ? 'Open Menu' : 'Close Menu'}
    >
      <CollapseIcon className={classNames(styles.icon, { [styles.iconCollapsed]: isCollapsed })} />
    </button>
  )
}

export default CollapseToggle
